import React from 'react'
import styled, { StyledProps } from 'styled-components'

type Size = 'small' | 'big'

const Wrapper = styled.div<StyledProps<{ size: Size }>>`
  background: ${({ theme }) => theme.color.accentNotify};
  border-radius: 12px;

  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;

  text-align: center;

  color: ${({ theme }) => theme.color.onPrimaryLight};

  ${({ size }) => {
    switch (size) {
      case 'small':
        return {
          width: '16px',
          height: '16px',
          lineHeight: '16px',
          marginLeft: '4px',
          padding: 'auto',
        }
      case 'big':
        return {
          lineHeight: '20px',
          padding: '2px 8px',
        }
    }
  }}
`

export const DiscountBadge: React.FC<{ text: string; className?: string; size?: 'small' | 'big' }> = ({
  text,
  className,
  size = 'big',
}) => {
  return (
    <Wrapper size={size} className={className}>
      {text}
    </Wrapper>
  )
}
